import { default as config } from '../config';
import productUtils from '../utils/productUtils';
import axios from 'axios';
import { serialize } from '../utils';
import auth from '../utils/auth';

function cleanFilters(filters) {
    let clearFilters = {};
    Object.keys(filters)
        .filter((key) => !key.toLowerCase().includes('utm_'))
        .forEach((key) => {
            clearFilters[key] = filters[key];
        });
    return clearFilters;
}

export function getProductsBySku(skus = []) {
    let qs = productUtils.makeSkuQuery(skus);
    return axios.get(`/products?${qs}`);
}

const serilaize = (data) => {
    let qs = [];
    for (let key in data) {
        qs.push(`${key}=${data[key]}`);
    }
    return qs.join('&');
};

export function searchProducts(term, filters = {}) {
    let qs = serilaize(filters);
    let params = qs ? `?${qs}` : '';
    return axios.get(`/products/search/${term}${params}`);
}

export function fetchProducts(pathname, sorting, filters, salesTerritoryRights, pageSize = 20) {
    let query = {
        ...cleanFilters(filters),
        start: filters.start || 0,
        sort: sorting.key ? `${sorting.key}:${sorting.order}` : undefined,
        page_size: pageSize,
        sites: config.channel
    };
    if (salesTerritoryRights) {
        query.sales_territory_rights = salesTerritoryRights;
    }
    let qs = serialize(query);
    let params = qs ? `?${qs}` : '';
    return axios.get(`${pathname}${params}`);
}
export function getItemHistories(skus, accountId, orgId) {
    let qs = serialize({
        items: skus,
        org: auth.getOrgId()
    });
    let params = qs ? `?${qs}` : '';
    return axios.request({
        url: `/orders/search${params}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Customer-Id': auth.getUserId(),
            'Session-Key': auth.getSID()
        }
    });
}
